/**
 * 公开网站 URL 工具
 *
 * 支持两种访问方式：
 * 1. 路径格式：sitedomain.com/e/{shortcode}
 * 2. 子域名格式：{shortcode}.sitedomain.com
 *
 * 前端通过 window.location 自动判断当前是哪种方式，
 * 生成公开链接时优先使用子域名格式（如果配置了 REACT_APP_SITE_DOMAIN）。
 */

// 平台主域名，部署时通过环境变量 REACT_APP_SITE_DOMAIN 配置
// 子域名格式：{shortcode}.REACT_APP_SITE_DOMAIN
// 路径格式：REACT_APP_SITE_DOMAIN/e/{shortcode}
const SITE_DOMAIN = process.env.REACT_APP_SITE_DOMAIN || ''

/**
 * 从当前 URL 提取 shortcode
 * 优先从子域名提取，fallback 到 URL 路径 /e/:shortcode
 */
export function extractShortcode(): string | null {
  // 1. 尝试从子域名提取
  const hostname = window.location.hostname
  if (SITE_DOMAIN) {
    const suffix = '.' + SITE_DOMAIN
    if (hostname.endsWith(suffix)) {
      const sub = hostname.slice(0, -suffix.length)
      // 排除 www 等非 shortcode 子域名
      if (sub && sub !== 'www' && sub !== 'app' && !sub.includes('.')) {
        return sub
      }
    }
  }

  // 2. 从路径 /e/:shortcode 提取
  const match = window.location.pathname.match(/^\/e\/([^/]+)/)
  if (match) {
    return match[1]
  }

  return null
}

/**
 * 根据 shortcode 生成公开访问链接
 * 优先返回子域名格式，fallback 到路径格式
 */
export function getPublicUrl(shortcode: string): string {
  if (SITE_DOMAIN) {
    return `https://${shortcode}.${SITE_DOMAIN}`
  }
  // 没有 SITE_DOMAIN 配置时，使用当前 origin + 路径格式
  return `${window.location.origin}/e/${shortcode}`
}

/**
 * 判断当前是否在公开网站模式（子域名或 /e/ 路径）
 */
export function isPublicWebsiteMode(): boolean {
  return extractShortcode() !== null
}
